import { Fragment, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TransitionalBusinessUnitSelect } from 'ui-business-units-lib/components/BusinessUnitSelect';
import { jsx as _jsx } from "react/jsx-runtime";
function BUButtonContent({
  multi,
  options,
  value
}) {
  const count = useMemo(() => {
    if (!multi) {
      return 0;
    }

    /**
     * "All business units" option is also propagated down as an option to BusinessUnitSelect
     * but it should not be counted in the ButtonContent
     */
    if (Array.isArray(value) && value.length === options.length + 1) {
      return value.length - 1;
    }
    return Array.isArray(value) ? value.length : 0;
  }, [multi, options.length, value]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: multi && Array.isArray(value) ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.buSelect.businessUnitsWithCounts_buv2",
      options: {
        count
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.buSelect.businessUnits_buv2"
    })
  });
}
export default function ConnectedBUSelect({
  disabled,
  multi,
  onChange,
  options,
  use,
  value,
  includeViewAll = true
}) {
  const buSelectProps = useMemo(() => {
    if (multi) {
      return {
        buIds: value
      };
    }
    return {
      buId: value
    };
  }, [multi, value]);
  return /*#__PURE__*/_jsx(TransitionalBusinessUnitSelect, Object.assign({
    buOptions: options,
    buttonUse: "transparent",
    "data-test-id": "crm-listing-bu-select",
    disabled: disabled,
    includeViewAll: includeViewAll,
    menuWidth: 400,
    multi: multi,
    onChange: onChange,
    ButtonContent: use === 'button' ? () => /*#__PURE__*/_jsx(BUButtonContent, {
      multi: multi,
      options: options,
      value: value
    }) : undefined
  }, buSelectProps, {
    selectProps: {
      paddingInline: '0'
    }
  }));
}